var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.938 5.625H2.063a.563.563 0 0 1-.563-.562v-1.5c0-.311.252-.563.563-.563h19.875c.31 0 .562.252.562.563v1.5c0 .31-.252.562-.562.562m0 7.5H2.063a.563.563 0 0 1-.563-.562v-1.5c0-.311.252-.563.563-.563h19.875c.31 0 .562.252.562.563v1.5c0 .31-.252.562-.562.562m0 7.5H2.063a.563.563 0 0 1-.563-.562v-1.5c0-.311.252-.563.563-.563h19.875c.31 0 .562.252.562.563v1.5c0 .31-.252.562-.562.562"
  })));
};
export default SvgMenu;